import CTLDateShow from "application/components/CTLDateShow";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { adminMenus } from "globals/configuration/admin";
import formControl from "globals/form-control";


const Attributes = {
  formSize: "md",
  enableAddButton: true,
  settingsMode: false,
  enableAdvanceSearch: false,
  
  modes: adminMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
    create: "company/create",
    update: "company/update",
    list: "company/list",
    delete: "company/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Created By",
      accessor: "createdBy",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      // validation: formControl.string().required("Required").nullable(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Created On",
      accessor: "createdOn",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      width: 6,
      // validation: formControl.string().required("Required").nullable(),
      Cell: ({ value }) => <CTLDateShow value={value} />,
    },
    {
      Header: "Code",
      accessor: "code",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      disabled:true,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Description",
      accessor: "description",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },

    {
      Header: "Address",
      accessor: "address",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Email",
      accessor: "email",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
